import api from "@/api";
import { forEach } from "lodash-es";

export default {
  namespaced: true,
  actions: {
    get(_, pagination) {
      return api.$get("/sale-records", pagination).then(res => res.data);
    },
    create(_, { salesRecord, onUploadProgress }) {
      const fd = new FormData();
      forEach(salesRecord, (val, key) => {
        fd.append(key, val);
      });
      return api
        .post("/sale-records", fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress
        })
        .then(res => res.data);
    },
    update(_, salesRecord) {
      return api
        .put(`/sale-records/${salesRecord.id}`, salesRecord)
        .then(res => res.data);
    },
    delete(_, saleRecord_id) {
      return api.delete(`/sale-records/${saleRecord_id}`).then(res => res.data);
    }
  }
};
